var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMyContent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#my_content_svg__a)",
  stroke: "#3A434A",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.846 18.585a1.4 1.4 0 0 0 1.256-1.31c.145-2.356.223-4.654.223-7.275 0-2.621-.078-4.919-.223-7.276a1.4 1.4 0 0 0-1.256-1.31c-3.928-.393-7.369-.393-11.296 0a1.4 1.4 0 0 0-1.256 1.31A114.972 114.972 0 0 0 1.071 10c0 2.621.078 4.919.223 7.276a1.4 1.4 0 0 0 1.256 1.31c3.927.392 7.369.392 11.296 0ZM15.325 2.871h2.095c.487 0 .958.242 1.159.686.512 1.132.436 2.212-.062 3.878a1.385 1.385 0 0 1-1.337.973h-1.855V2.871Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.325 8.408h2.095c.487 0 .958.242 1.159.686.512 1.132.436 2.212-.062 3.878a1.385 1.385 0 0 1-1.337.973h-1.855V8.408ZM10.251 4.914H6.146c-.592 0-1.072.48-1.072 1.072v1.443c0 .591.48 1.071 1.072 1.071h4.105c.592 0 1.072-.48 1.072-1.071V5.986c0-.592-.48-1.072-1.072-1.072Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "my_content_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
})))));
export default SvgMyContent;